module.exports = __webpack_public_path__ + "media/images/pdf-file-875de720.svg";